import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { DISPATCH_STATUS_ENUM } from '../constants/dispatch.enum';
import { DispatchService } from '../services';
import { DISPATCHES_LIST_KEY, DISPATCHES_ONE_KEY } from '../constants';

const useUpdateDispatchStatus = (id: string) => {
  const { t } = useTranslation('page');
  const queryClient = useQueryClient();

  const { mutate, isPending: isLoading } = useMutation(
    (status: DISPATCH_STATUS_ENUM) => DispatchService.updateStatus(id, status),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [DISPATCHES_LIST_KEY] });
        queryClient.invalidateQueries({ queryKey: [id, DISPATCHES_ONE_KEY] });
        toast.success(t('manufacture:statusSuccessUpdate'));
      },
      onError: (error: any) => {
        toast.error(t(error?.reference, { ns: 'errors', count: error?.pendingWarehouseDispatches }));
      },
    },
  );

  return {
    updateStatus: mutate,
    isLoading,
  };
};

export default useUpdateDispatchStatus;
